export function notify(
  title,
  message,
  type = 'success',
  icon = 'fa-regular fa-circle-check'
) {
  const event = new CustomEvent('show-notification', {
    detail: {
      messageTitle: title,
      messageText: message,
      typeText: type,
      iconText: icon
    }
  })
  window.dispatchEvent(event)
}

export function getGenderName(genderCode) {
  switch (genderCode) {
    case 'male':
    case 'M':
      return 'Masculino'
    case 'female':
    case 'F':
      return 'Femenino'
    case 'other':
    case 'O':
      return 'Otro'
    default:
      return genderCode || 'No especificado'
  }
}

export function getFullFormatDate(dateString) {
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }
  return new Date(dateString)
    .toLocaleString('es-ES', options)
    .replace(' a. m.', ' a.m.')
    .replace(' p. m.', ' p.m.')
}

export function getFormatDate(dateString) {
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }
  return new Date(dateString).toLocaleString('es-ES', options)
}

export function formatCurrency(value, currency = 'MXN', locale = 'es-MX') {
    if (value === null || value === undefined || isNaN(value)) return '$0.00';
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(Number(value));
}